// lowercase, so we have case-insensitive search
export enum FiltersParams {
    bpmlowerbound = 'bpmlowerbound',
    bpmupperbound = 'bpmupperbound',
    instruments = 'instruments',
    genres = 'genres',
    keyquality = 'keyquality',
    keyrootnote = 'keyrootnote',
    orderby = 'orderby',
    orderbydirection = 'orderbydirection',
    tags = 'tags',
    textsearch = 'textsearch',
    type = 'type',
    sfxs = 'sfxs',
}

export enum TagCategoryParams {
    artist = 'artist',
    timbre = 'timbre',
    mood = 'mood',
    city = 'city',
    music_gear = 'music_gear',
    other = 'other',
}

export enum NavigationParams {
    page = 'page',
    tab = 'tab',
}

export enum AudioConfigParams {
    autoPlay = 'autoplay',
}

export const Params = {
    ...NavigationParams,
    ...FiltersParams,
    ...AudioConfigParams,
};
